<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-layout row wrap>
      <v-flex sm12 md12>
        <v-card>
          <v-card-title>
            <span class="headline"
              >{{
                user && user.customer_id ? "Editar" : "Inscrever"
              }}
              Membro</span
            >
            <v-spacer />
            <span style="padding-right: 10px">{{
              user ? user.customer_id : ""
            }}</span>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon left @click="backQueue" v-on="on">swipe_left</v-icon>
              </template>
              <span>Voltar para a Fila</span>
            </v-tooltip>
            <!-- <v-btn color="tertiary" small outline @click="dialog_calculator = true">
                <v-icon left>calculate</v-icon>Proposta
              </v-btn> -->
          </v-card-title>
          <v-card-text>
            <v-alert
              v-if="user && user.customer_id && user.signedcontract_at"
              :value="true"
              type="warning"
            >
              <p v-html="assinou" />
            </v-alert>
            <v-alert v-if="cpf_duplicated" :value="true" type="warning">
              <p v-html="cpf_duplicated_msg" />
            </v-alert>
            <v-alert v-if="cpf_duplicated" :value="true" type="warning">
              <p v-html="cpf_duplicated_msg" />
            </v-alert>
            <v-alert v-if="financial_pending" :value="true" type="error">
              <p v-html="financial_pending" />
            </v-alert>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md6 lg3>
                  <v-select
                    :items="person_type_items"
                    item-value="value"
                    item-text="text"
                    label="Entidade*"
                    v-model="person_type"
                    :rules="[(v) => !!v || 'Por favor, informe o tipo']"
                    required
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm6 md3 lg3>
                  <v-text-field
                    id="cpf"
                    v-model="cpf"
                    autofocus
                    :label="person_type === 'pf' ? 'CPF' : 'CNPJ'"
                    :mask="
                      person_type === 'pf'
                        ? '###.###.###-##'
                        : '##.###.###/####-##'
                    "
                    append-icon="launch"
                    @click:append="show_dialog_ucs"
                    @click:append-outer="buscaDadosComplementares(cpf, false)"
                    append-outer-icon="autorenew"
                    :rules="
                      person_type === 'pf'
                        ? [
                            (v) => v.length >= 11 || 'Preencha o CPF Completo',
                            (v) =>
                              this.validaCPF(this.cpf) === true ||
                              'CPF inválido',
                            // v => this.validaCPFNaBase(this.cpf).value === true || 'CPF já existe na base'
                          ]
                        : [
                            (v) => v.length >= 14 || 'Preencha o CNPJ Completo',
                            (v) =>
                              this.validaCNPJ(this.cpf) === true ||
                              'CNPJ inválido',
                            // v => this.validaCPFNaBase(this.cpf).value === true || 'CPF já existe na base'
                          ]
                    "
                    @change="buscaMember($event, 'cpf')"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4 lg3>
                  <v-text-field
                    label="E-mail"
                    v-model="email"
                    read-only
                    hint="E-mail principal do membro"
                    :rules="[
                      (v) => !!v || 'Por favor, informe o email',
                      (v) =>
                        /^(([^<>()\[\]\\.,;:\s@&quot;]+(\.[^<>()\[\]\\.,;:\s@&quot;]+)*)|(&quot;.+&quot;))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/.test(
                          v,
                        ) || 'E-mail precisa ser válido',
                    ]"
                    name="email"
                    :disabled="user.customer_id ? true : false"
                    type="email"
                    required
                    @click:append="buscaMember(email, 'email')"
                    append-icon="autorenew"
                    @change="buscaMember($event, 'email')"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm6 md6 lg3>
                  <v-text-field
                    label="Média de Consumo"
                    v-model.number="average"
                    name="average"
                    :rules="[
                      (v) => !!v || 'Por favor, informe a média de consumo',
                    ]"
                    required
                  ></v-text-field>
                </v-flex>
                <v-layout row wrap v-if="ucs_list">
                  <v-flex xs12>
                    <p class="font-weight-bold">
                      Esse cliente já possui unidades consumidoras cadastradas.
                    </p>
                  </v-flex>
                  <v-flex v-for="list in ucs_list" :key="list.id">
                    <v-card max-width="310">
                      <v-card-title>
                        <v-flex xs2>
                          <v-icon large left> home </v-icon>
                        </v-flex>
                        <v-flex xs5>
                          <!-- <v-chip>{{list.status}}</v-chip> -->
                          <span class="title font-weight-light">{{
                            list.id
                          }}</span>
                        </v-flex>
                        <v-flex>
                          <v-tooltip
                            bottom
                            v-if="
                              list.status === 'canceling' ||
                              list.status === 'canceled'
                            "
                          >
                            <template v-slot:activator="{ on }">
                              <v-btn
                                small
                                dark
                                round
                                :color="list.status | formatUCStatusColor"
                                v-on="on"
                              >
                                <strong>{{
                                  list.status | formatUCStatus
                                }}</strong>
                              </v-btn>
                            </template>
                            <span
                              v-if="
                                list.status_reason ||
                                list.status_reason_description
                              "
                              ><br />
                              <div v-if="list.canceled_at">
                                <strong>Cancelado em: </strong
                                >{{ list.canceled_at | formatarDate }}
                                <br /><br />
                              </div>
                              <strong>Motivo: </strong
                              >{{ list.status_reason | formatStatusReason
                              }}<br /><br />
                              <strong>Descrição: </strong
                              >{{ list.status_reason_description }}
                            </span>
                            <span v-else>Motivo: {{ list.bot_status }}</span>
                          </v-tooltip>
                          <v-btn
                            small
                            dark
                            round
                            :color="list.status | formatUCStatusColor"
                            v-else
                          >
                            <strong>{{ list.status | formatUCStatus }}</strong>
                          </v-btn>
                        </v-flex>
                      </v-card-title>
                      <v-card-text>
                        <p class="font-weight-bold subtitle">{{ list.name }}</p>
                        <p
                          class="caption"
                          v-if="list.address && list.address.address"
                        >
                          {{ list.address.address }},
                          {{ list.address.address_number }},
                          {{ list.address.district }},
                          {{ list.address.city }}/{{
                            list.address.state.initials
                          }}
                          - CEP:
                          {{ list.address.postal_code }}
                        </p>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs12>
                    <v-btn
                      dark
                      @click.prevent="buscaDadosComplementares(cpf, false)"
                      >Adicionar Unidades Consumidoras</v-btn
                    >
                  </v-flex>
                  <v-flex xs12>
                    <v-alert
                      v-if="
                        ucs_list && ucs_list.length > 0 && status === 'ATIVO'
                      "
                      :value="true"
                      type="warning"
                    >
                      <p
                        v-html="
                          'Só é possivel adicionar novas unidades consumidoras. Para reativar unidades já cadastradas é necessário fazer pela tela de Clientes.'
                        "
                      />
                    </v-alert>
                  </v-flex>
                </v-layout>
                <v-container pa-0 v-if="average > 0">
                  <v-layout row wrap>
                    <v-flex
                      v-for="plan in plansEconomySort"
                      :key="plan.id"
                      xs6
                      sm4
                      md4
                      lg4
                    >
                      <!-- <v-card @click.prevent="choosePlan(plan)" class="ma-1 card_border" hover :style="(selected_plan && selected_plan.id === plan.id) || (!selected_plan && plan.recommended) ? 'border: 1px solid blue;' : 'border: 1px solid #c0c0c0;'"> -->
                      <v-card
                        @click.prevent="choosePlan(plan)"
                        class="ma-1 card_border"
                        hover
                        :style="
                          selected_plan && selected_plan.id === plan.id
                            ? 'border: 1px solid blue;'
                            : 'border: 1px solid #c0c0c0;'
                        "
                      >
                        <v-flex xs12 class="pa-0 ma-0">
                          <div style="background: #efefef">
                            <v-icon
                              size="36px"
                              left
                              color="blue"
                              v-if="
                                selected_plan && selected_plan.id === plan.id
                              "
                            >
                              check_circle
                            </v-icon>
                          </div>
                          <h4
                            class="pa-2 mt-0 mb-0 text-xs-center font-weight-bold"
                            style="background: #efefef"
                          >
                            {{ plan.name }}
                          </h4>
                          <div
                            class="body-3 pt-1 mt-0 mb-0 blue--text text-xs-center font-weight-bold"
                            style="
                              border-bottom-width: 2px;
                              border-bottom-style: solid;
                              border-bottom-color: #efefef;
                            "
                          >
                            {{ plan.discount }}% de desconto
                          </div>
                          <h5 class="pt-0 pb-0 mb-1 mt-2 text-xs-center">
                            Economize até
                          </h5>
                          <div
                            class="pt-0 text-xs-center display-1 text-no-wrap"
                          >
                            <small class="body-1">R$ </small
                            >{{ plan.economy_year | formatCurrency
                            }}<small class="body-1"> ao ano</small>
                          </div>
                          <!-- <div class="caption text-xs-center">{{economy_label}}</div> -->
                        </v-flex>
                        <v-layout xs6 class="text--center justify-center">
                          <div
                            class="body-2 px-4 py-1 black--text text-xs-center"
                            style="background: #efefef; border-radius: 10px"
                          >
                            R$
                            <span class="font-weight-bold text-xs-center">{{
                              plan.economy_mounth | formatCurrency
                            }}</span>
                            por mês
                          </div>
                        </v-layout>
                        <plan-conditions :plan="plan" />
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-container>

                <v-flex
                  xs12
                  sm12
                  md12
                  v-if="qualifications && qualifications.length > 0"
                >
                  <v-list three-line>
                    <template v-for="(qualification, idx) in qualifications">
                      <qualifying-card
                        :key="idx"
                        :qualification="qualification"
                        :installations_found="ucs_cemig"
                        v-if="qualification.status === 'pending'"
                      />
                      <not-qualified-card
                        :key="idx"
                        :qualification="qualification"
                        :installations_found="ucs_cemig"
                        v-if="
                          qualification.status === 'bill_not_found' ||
                          qualification.status === 'error'
                        "
                      />
                      <disqualified-card
                        :key="idx"
                        :qualification="qualification"
                        :installations_found="ucs_cemig"
                        v-if="qualification.status === 'disqualified'"
                      />
                      <qualified-card
                        :key="idx"
                        :qualification="qualification"
                        :installations_found="ucs_cemig"
                        v-if="qualification.status === 'qualified'"
                      />
                    </template>
                  </v-list>
                </v-flex>
                <v-layout
                  row
                  wrap
                  v-if="
                    !(ucs_list && ucs_list.length > 0 && status === 'ATIVO')
                  "
                >
                  <v-flex xs12 sm3 md3>
                    <v-select
                      :items="enercred_contract_items"
                      item-value="value"
                      item-text="text"
                      label="Gerar contrato da Juntos?"
                      v-model="enercred_contract"
                      :rules="[
                        (v) =>
                          v !== '' ||
                          'Por favor, informe se deve ser gerado contrato da Enercred',
                      ]"
                      required
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm9 md6>
                    <v-text-field
                      v-if="person_type === 'pj'"
                      label="Razão Social"
                      v-model="company_name"
                      type="text"
                      required
                      :rules="[
                        (v) =>
                          !!v || 'Por favor, informe a razão social da empresa',
                      ]"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      :label="
                        'Nome Completo' +
                        (person_type === 'pj' ? ' do Representante Legal' : '')
                      "
                      v-model="name"
                      type="text"
                      required
                      :hint="nome_titular"
                      :rules="[
                        (v) => !!v || 'Por favor, informe o seu nome',
                        (v) =>
                          v.length >= 10 ||
                          'Por favor, preencha o nome completo.',
                      ]"
                    ></v-text-field>
                    <input
                      type="hidden"
                      name="nome_titular"
                      v-model="nome_titular"
                    />
                  </v-flex>
                  <v-flex xs12 sm5 md3>
                    <v-text-field
                      type="tel"
                      v-model="phone"
                      :rules="[
                        (v) => !!v || 'Por favor, informe o celular',
                        (v) =>
                          v.length > 10 ||
                          'Ops. Parece que esse não é um número de telefone',
                      ]"
                      prepend-icon="phone"
                      @click:prepend="call(phone)"
                      return-masked-value
                      mask="(##)#####-####"
                      label="Telefone"
                      hint="Preferencialmente um telefone com whatsapp"
                      persistent-hint
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm1 md1 pt-4>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon @click="dialog_phones = true" v-on="on"
                          >add</v-icon
                        >
                      </template>
                      <span>Mais telefones</span>
                    </v-tooltip>
                    <span
                      v-if="
                        phones &&
                        phones.length > 0 &&
                        phones.filter((p) => p.phone !== '').length != 0
                      "
                      class="caption"
                    >
                      {{
                        phones && phones.length > 0
                          ? phones.filter((p) => p.phone !== "").length
                          : 0
                      }}
                    </span>
                  </v-flex>

                  <v-flex xs12 sm6 md4 v-if="person_type === 'pj'">
                    <v-text-field
                      id="cpf_legal_responsible"
                      v-if="person_type === 'pj'"
                      v-model="cpf_legal_responsible"
                      autofocus
                      label="CPF do Representante Legal"
                      :mask="'###.###.###-##'"
                      :rules="[
                        (v) =>
                          !!v ||
                          'Por favor, informe o CPF do representante legal da empresa!',
                        (v) => v.length >= 11 || 'Preencha o CPF Completo',
                        (v) =>
                          this.validaCPF(this.cpf_legal_responsible) === true ||
                          'CPF inválido',
                        // v => this.validaCPFNaBase(this.cpf).value === true || 'CPF já existe na base'
                      ]"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md2 v-if="person_type === 'pf'">
                    <v-text-field
                      id="rg"
                      v-model="rg"
                      label="Documento"
                      hint="RG ou outro oficial"
                      :rules="[
                        (v) =>
                          v.length > 7 ||
                          'Ops. Parece que esse não é um número valido',
                      ]"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md2 v-if="person_type === 'pf'">
                    <v-text-field
                      id="orgao_expeditor"
                      v-model="orgao_expeditor"
                      label="Orgão Expeditor"
                      hint="ex. SSP/MG"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md3 v-if="person_type === 'pf'">
                    <v-text-field
                      label="Data de Nasc"
                      v-model="birthday"
                      mask="##/##/####"
                      :rules="[
                        (v) =>
                          v.length > 9 ||
                          'Ops. Parece que esse não é um data valida',
                      ]"
                      return-masked-value
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md1 v-if="person_type === 'pf'">
                    <v-select
                      :items="['M', 'F']"
                      label="Sexo"
                      v-model="gender"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm3 md2>
                    <v-text-field
                      id="cep"
                      v-model="cep"
                      label="CEP"
                      mask="#####-###"
                      :rules="[
                        (v) =>
                          v.length > 7 ||
                          'Ops. Parece que esse não é um CEP válido',
                      ]"
                      @change="buscaCep($event)"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm1 md1>
                    <v-progress-circular
                      v-if="loading_cep"
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                  </v-flex>
                  <v-flex xs12 sm8 md5>
                    <v-text-field
                      id="logradouro"
                      v-model="logradouro"
                      label="Logradouro"
                      hint="opcional"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md1>
                    <v-text-field
                      id="numero"
                      v-model="numero"
                      label="Número"
                      hint="opcional"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md2>
                    <v-text-field
                      id="complemento"
                      v-model="complemento"
                      label="Complemento"
                      hint="opcional"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <v-text-field
                      id="bairro"
                      v-model="bairro"
                      label="Bairro"
                      hint="opcional"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <v-text-field
                      id="localidade"
                      v-model="localidade"
                      label="Cidade"
                      hint="opcional"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <v-autocomplete
                      :items="states"
                      item-text="name"
                      item-value="initials"
                      label="Estado"
                      prepend-icon="map"
                      v-model="state"
                      return-object
                      :rules="[
                        (v) => !!v || 'Por favor, selecione o seu estado!',
                      ]"
                      hint="Selecione o estado"
                      required
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <v-select
                      :items="payment_type_items"
                      item-value="value"
                      item-text="text"
                      label="Metodo de Pagamento*"
                      v-model="payment_type"
                      :rules="[
                        (v) =>
                          !!v || 'Por favor, informe o método de pagamento',
                      ]"
                      required
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <v-select
                      :items="['Chat', 'Telefone', 'Representante Comercial']"
                      label="Meio da Inscrição"
                      v-model="signedcontract_by"
                      :rules="[
                        (v) =>
                          !!v ||
                          'Por favor, informe se a inscrição está ocorrendo por telefone ou chat',
                      ]"
                      required
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm6 md3 v-if="status">
                    <v-text-field
                      v-model="status"
                      label="Status do Membro"
                      hint="readonly"
                      readonly
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm3 md3 v-if="psellers">
                    <v-autocomplete
                      :items="psellers"
                      item-text="name"
                      item-value="email"
                      label="Vendido por"
                      v-model="signedcontract_partner"
                      hint="opcional"
                    ></v-autocomplete>
                  </v-flex>

                  <v-flex xs9 sm9 md9>
                    <v-combobox
                      v-model="ucs"
                      :filter="filter"
                      :hide-no-data="!search"
                      :items="items"
                      :search-input.sync="search"
                      hide-selected
                      label="Número(s) de Instalação(s) CEMIG"
                      multiple
                      small-chips
                      solo
                    >
                      <template v-slot:no-data>
                        <v-list-tile>
                          <span class="subheading">[Enter] Criar</span>
                          <v-chip
                            :color="`${colors_uc[nonce - 1]} lighten-3`"
                            label
                            small
                          >
                            {{ search }}
                          </v-chip>
                        </v-list-tile>
                      </template>
                      <template v-slot:selection="{ item, parent, selected }">
                        <v-chip
                          v-if="item === Object(item)"
                          :color="`${item.color} lighten-3`"
                          :selected="selected"
                          label
                          small
                        >
                          <span class="pr-2">
                            {{ item.text }}
                          </span>
                          <v-icon small @click="parent.selectItem(item)"
                            >close</v-icon
                          >
                        </v-chip>
                      </template>
                      <template v-slot:item="{ index, item }">
                        <v-list-tile-content>
                          <v-text-field
                            v-if="editing === item"
                            v-model="editing.text"
                            autofocus
                            flat
                            background-color="transparent"
                            hide-details
                            solo
                            @keyup.enter="edit(index, item)"
                          ></v-text-field>
                          <v-chip
                            v-else
                            :color="`${item.color} lighten-3`"
                            dark
                            label
                            small
                          >
                            {{ item.text }}
                          </v-chip>
                        </v-list-tile-content>
                        <v-spacer></v-spacer>
                        <v-list-tile-action @click.stop>
                          <v-btn icon @click.stop.prevent="edit(index, item)">
                            <v-icon>{{
                              editing !== item ? "edit" : "check"
                            }}</v-icon>
                          </v-btn>
                        </v-list-tile-action>
                      </template>
                    </v-combobox>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <v-select
                      :items="['Trabalhar', 'Sem interesse']"
                      label="Ação necessária"
                      v-model="status_lead"
                      :rules="[
                        (v) =>
                          !!v || 'Por favor, informe o que fazer com esse lead',
                      ]"
                      required
                    ></v-select>
                  </v-flex>
                  <v-flex xs4 sm4 md12>
                    <v-text-field
                      v-model="cupom"
                      label="Cupom de desconto (Opcional)"
                      prepend-icon="mdi-sale"
                      name="cupom"
                      required
                      filled
                      rounded
                      dense
                      ref="cupom"
                      @keyup="uppercaseCoupon"
                      @keypress="clearCupom"
                      @keydown="clearCupom"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs2 sm2 md12>
                    <v-btn
                      color="indigo"
                      small
                      @click="validateCupom(cupom)"
                      :loading="loadingCupom"
                      :disabled="loadingCupom"
                    >
                      Aplicar
                    </v-btn>
                  </v-flex>
                  <v-flex xs6 sm6 md12>
                    <div
                      v-if="!isValidCoupon && couponMessage"
                      class="red--text font-weight-bold"
                    >
                      {{ couponMessage }}
                    </div>
                    <div
                      v-else-if="isValidCoupon && couponMessage"
                      class="green--text font-weight-bold"
                    >
                      {{ couponMessage }}
                    </div>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-textarea
                      v-model="sales_observation"
                      label="Observação"
                      placeholder="Escreva uma observação que desejar sobre a venda e contato realizado..."
                    ></v-textarea>
                  </v-flex>
                </v-layout>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="close">fechar</v-btn>
            <v-btn
              color="green darken-1"
              :disabled="
                loading || (lead && lead.user && lead.user.status === 'ATIVO')
              "
              @click.prevent="save"
              >{{
                loading
                  ? save_btn_label
                  : is_disqualification
                    ? "Concluir"
                    : "Salvar"
              }}</v-btn
            >
            <v-btn
              color="blue darken-1"
              v-if="!lead.user || (lead.user && !lead.user.status)"
              :loading="loading"
              :disabled="loading || is_disqualification || isQualifing"
              @click.prevent="validate"
              type="submit"
              >Inscrever</v-btn
            >

            <v-btn
              color="blue darken-1"
              v-else-if="ucs_list && ucs_list.length > 0 && status === 'ATIVO'"
              :loading="loading"
              :disabled="
                loading ||
                is_disqualification ||
                isQualifing ||
                qualification_ids.length <= 0
              "
              @click.prevent="addUC"
              type="submit"
              >Adicionar Novas UCs</v-btn
            >

            <v-btn
              color="blue darken-1"
              v-else
              :loading="loading"
              :disabled="
                loading ||
                !canSubscription ||
                is_disqualification ||
                isQualifing
              "
              @click.prevent="reSubscription"
              type="submit"
              >Re-Inscrever</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <v-snackbar
      :color="color"
      :bottom="bottom"
      :top="top"
      :left="left"
      :right="right"
      multi-line
      v-model="snackbar"
      dark
    >
      <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
      <div v-html="snackMessage"></div>
      <v-icon size="16" @click="snackbar = false"> mdi-close-circle </v-icon>
    </v-snackbar>
  </v-form>
</template>

<script>
import QualifiedCard from "../../components/sales/qualification/QualifiedCard.vue";
import DisqualifiedCard from "../../components/sales/qualification/DisqualifiedCard.vue";
import QualifyingCard from "../../components/sales/qualification/QualifyingCard.vue";
import NotQualifiedCard from "../../components/sales/qualification/NotQualifiedCard.vue";
import PlanConditions from "../../components/plans/PlanConditions.vue";
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  props: [
    "dialog_member",
    "cpf_duplicated",
    "cpf_duplicated_msg",
    "dialog_ucs",
    "dialog_cpf",
    "dialog_venda",
    "dialog_app",
    "dialog_calculator",
    "dialog_phones",
    "financial_pending",
    "label_loading_cpf",
    "ucs_chbox",
    "valid",
    "profissoes",
    "lead",
    "cadLead",
    "name",
    "nome_titular",
    "phone",
    "phones",
    "email",
    "average",
    "person_type_items",
    "enercred_contract_items",
    "contract_time_items",
    "enercred_contract",
    "person_type",
    "company_name",
    "cpf",
    "old_cpf",
    "cpf_legal_responsible",
    "rg",
    "birthday",
    "mother_name",
    "orgao_expeditor",
    "user",
    "marital_status",
    "marital_status_value",
    "marital_type",
    "marital_type_value",
    "gender",
    "cemig_status",
    "cep",
    "logradouro",
    "numero",
    "complemento",
    "bairro",
    "localidade",
    "uf",
    "state",
    "profissao",
    "consumer_unit",
    "states",
    "payment_type_items",
    "payment_type",
    "sales_observation",
    "status",
    "signedcontract_at",
    "signedcontract_partner",
    "signedcontract_by",
    "loading",
    "loading_cpf",
    "loading_cep",
    "loading_qualification",
    "color",
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_term",
    "utm_content",
    "platform",
    "colors",
    "top",
    "bottom",
    "left",
    "right",
    "snackMessage",
    "snackbar",
    "currentUser",
    "activator",
    "attach",
    "colors_uc",
    "editing",
    "index",
    "items",
    "nonce",
    "menu",
    "ucs",
    "status_lead",
    "applestore",
    "googleplay",
    "contract_time",
    "contract_time_enable",
    "ucs_list",
    "ucs_cemig",
    "uc",
    "qualification_ids",
    "is_disqualification",
    "x",
    "search",
    "y",
    "cupom",
    "isValidCoupon",
    "couponMessage",
    "loadingCupom",
    "psellers",
    "plans_economy",
    "selected_plan",
    "docfrente",
    "docverso",
    "docself",
    "dialog_fotos",
    "e6",
    "fileInfo",
    "save_btn_label",
    "tabulation",
    "isCorreiosUser",
    "canSubscription",
    "assinou",

    "backQueue",
    "show_dialog_ucs",
    "buscaDadosComplementares",
    "validaCPF",
    "validaCNPJ",
    "buscaMember",
    "choosePlan",
    "call",
    "buscaCep",
    "edit",
    "uppercaseCoupon",
    "clearCupom",
    "validateCupom",
    "save",
    "validate",
    "reSubscription",
    "filter",
    "close",
  ],
  components: {
    QualifiedCard,
    DisqualifiedCard,
    QualifyingCard,
    NotQualifiedCard,
    PlanConditions,
  },
  methods: {
    ...mapActions("members", ["getUserByID"]),
    ...mapActions("qualification", ["resetState", "getQualifications"]),
    ...mapActions("sales", ["getCoupons", "getTabulations"]),
  },
  computed: {
    ...mapState("sales", ["coupon", "plans", "tabulations"]),
    ...mapGetters("qualification", ["qualifications", "isQualifing"]),
  },
};
</script>
